import { sendMessageToPlugins } from './chromeExtensionUtils';

export const loginPlugin = async (closeWindow = false, accessToken, refreshToken, fresh = false) => {
  let usedFallback = false;
  try {
    const result = await sendMessageToPlugins({
      message: 'login',
      accessToken,
      refreshToken,
      // Interactive sign-ins are marked fresh; the extension refuses passive
      // mount-time pushes while a plugin-side logout awaits acknowledgement.
      fresh,
    });
    usedFallback = result?.fallback === true;
  } catch (error) {
    console.warn('Failed to send login message to plugin:', error.message);
  } finally {
    // Always close the window if requested, even on error.
    // This prevents "loader forever" issue when the extension
    // isn't installed, doesn't respond, or fails to close the tab itself.
    if (closeWindow) {
      if (usedFallback) {
        // DOM fallback was used — delay close to give the extension's content script
        // time to detect and read the auth token from the DOM element.
        setTimeout(() => window.close(), 3000);
      } else {
        window.close();
      }
    }
  }
};

export const logoutPlugin = async () => {
  try {
    await sendMessageToPlugins({
      message: 'logout',
    });
  } catch (error) {
    console.warn('Failed to send logout message to plugin:', error.message);
  }
};
